import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import {
  Collapse,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col
} from "reactstrap";
import "assets/custom/custom.css";

const pageSideBar = {
  paddingLeft: "15px",
  fontSize: "0.7rem"
};

const securitySideBar = {
  paddingLeft: "15px",
  paddingTop: "20px",
  fontSize: "0.7rem"
};

const Sidebar = (props) => {
  const auth = JSON.parse(localStorage.getItem('auth'));
  let history = useHistory();
  const { routes, logo } = props;
  const [state, setState] = useState({ collapseOpen: false });

  useEffect(() => {
    let mounted = true;

    const activeRoute = (routeName) => {
      return props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    };

    if (mounted) {
      activeRoute();

      if (auth === null) {
        history.push('/auth/login');
      }
    }
    
    return () => {
      mounted = false;
    };
  }, []);

  const toggleCollapse = () => {
    setState(state => ({ state, collapseOpen: !state.collapseOpen }) )
  };

  const closeCollapse = () => {
    setState(state => ({ state, collapseOpen: false }) )
  };

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      return (
        <>
        <NavItem key={`${prop.path}${key}`}>
        {
          auth !== null
            ? auth.username == 'admin' 
              ? prop.name !== 'User Details'
                ?
                  <NavLink
                    to={`${prop.layout}${prop.path}`}
                    tag={NavLinkRRD}
                    onClick={closeCollapse}
                    activeClassName='active'
                  >
                    <i className={prop.icon} />
                    {prop.name}
                  </NavLink>
                : '' 
              : 
                prop.name !== 'User Details' && prop.name !== 'User Management'
                ?
                  <NavLink
                    to={`${prop.layout}${prop.path}`}
                    tag={NavLinkRRD}
                    onClick={closeCollapse}
                    activeClassName='active'
                  >
                    <i className={prop.icon} />
                    {prop.name}
                  </NavLink>
                : '' 
            : ''
        }
        </NavItem>
        </>
      );
    });
  };

  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: '_blank'
    };
  }
  
  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              className="navbar-brand-img navbar-logo"
              alt={logo.imgAlt}
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}
        <Collapse navbar isOpen={state.collapseOpen}>
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <Form className="mt-4 mb-3 d-md-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>
          <Nav navbar>{createLinks(routes)}</Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string,
    // the alt for the img
    imgAlt: PropTypes.string
  })
};

export default Sidebar;
